import { ItiBaseDto } from '@/iti-core-vue';

export class Noticia extends ItiBaseDto {
    public titular!: string;
    public mancheta!: string;
    public autor!: string;
    public contenido!: string;
    public categoria!: string;
    public instituto!: string;
    public fechaDePublicacion!: Date;
}
